export default {
    apiGateway: {
      REGION: "eu-west-1",   
    //   URL: "https://webapi.4gflota.com/api/"
        URL: "https://4yahqnkrsh.execute-api.eu-west-1.amazonaws.com/Prod/api/"  //desarrollo
    },
  };